import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import * as signalR from '@microsoft/signalr';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { of as observableOf, Observable, BehaviorSubject, firstValueFrom } from 'rxjs';

@Injectable()
export class SignalrService {

  private jobsHubUrl: string;
  private connectorHubUrl: string;
  private jobsHubConnection: any;
  private connectorHubConnection: any;

    constructor(private oidcSecurityService: OidcSecurityService) {
        this.jobsHubUrl = environment.signalrService.jobsHubUrl; // 'http://localhost:7163/api/signalr';
        this.connectorHubUrl = environment.signalrService.connectorHubUrl;
    }

    public async initiateJobsConnection(): Promise<any> {

      if (this.jobsHubConnection) {
          return this.jobsHubConnection;
        }

        this.jobsHubConnection = new signalR.HubConnectionBuilder()
            .withUrl(this.jobsHubUrl, {
                accessTokenFactory: () => firstValueFrom(this.oidcSecurityService.getAccessToken()),
                transport: signalR.HttpTransportType.WebSockets
            })
            .configureLogging(signalR.LogLevel.Debug)
            .withAutomaticReconnect()
            .build();

          this.startJobs();
          return this.jobsHubConnection;
    }

    public async initiateConnectorConnection(): Promise<any> {

        if (this.connectorHubConnection) {
          return this.connectorHubConnection;
        }

        this.connectorHubConnection = new signalR.HubConnectionBuilder()
          .withUrl(this.connectorHubUrl, {
                accessTokenFactory: () => firstValueFrom(this.oidcSecurityService.getAccessToken()),
                transport: signalR.HttpTransportType.WebSockets
            })
          .configureLogging(signalR.LogLevel.Debug)
          .withAutomaticReconnect()
          .build();

        this.startConnector();
        return this.connectorHubConnection;
    }

    private async startJobs() {
        try {
            await this.jobsHubConnection.start({ withCredentials: false });
            // console.assert(this.jobsHubConnection.state === signalR.HubConnectionState.Connected);
            // console.log('SignalR Connected.');
        } catch (err) {
            // console.assert(this.jobsHubConnection.state === signalR.HubConnectionState.Disconnected);
            // console.log(`SignalR connection error: ${err}. Retry in 5 seconds...`);
            setTimeout(() => this.startJobs(), 5000);
        }
    }

    private async startConnector() {
        try {
            await this.connectorHubConnection.start({ withCredentials: false });
            // console.assert(this.connectorHubConnection.state === signalR.HubConnectionState.Connected);
            // console.log('SignalR Connected.');
        } catch (err) {
            // console.assert(this.connectorHubConnection.state === signalR.HubConnectionState.Disconnected);
            // console.log(`SignalR connection error: ${err}. Retry in 5 seconds...`);
            setTimeout(() => this.startConnector(), 5000);
        }
    }
  }
